/* Shalom Bonic: detalles de ficha de producto (linea de cuotas y pestañas rapidas) */
(function(){
  if(window.__sbFicha) return; window.__sbFicha=1;
  if(location.pathname.indexOf('/products/')!==0) return;
  try{ if(new URLSearchParams(location.search).get('drawer')==='1') return; }catch(e){}
  var SEL='form[action*="/cart/add"] .gp-button-atc, form[action*="/cart/add"] button[name="add"]';
  function visible(el){
    if(!el) return false;
    var r=el.getBoundingClientRect(), s=getComputedStyle(el);
    return s.display!=='none'&&s.visibility!=='hidden'&&r.width>0&&r.height>0;
  }
  function mainBtn(){
    var l=document.querySelectorAll(SEL);
    for(var i=0;i<l.length;i++){ if(!l[i].closest('#sb-sticky')&&visible(l[i])) return l[i]; }
    return null;
  }
  function largo(el){ return (el.textContent||'').replace(/\s+/g,' ').trim().length; }
  function nodos(re){
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null), n, l=[];
    while((n=w.nextNode())){
      var p=n.parentElement; if(!p) continue;
      var t=p.tagName; if(t==='SCRIPT'||t==='STYLE'||t==='NOSCRIPT') continue;
      if(p.closest('#sb-tabs,#sb-conf,#sb-sticky,#sb-cuotas')) continue;
      if(re.test(n.nodeValue)) l.push(n);
    }
    return l;
  }
  var st=document.createElement('style');
  st.textContent=
    '#sb-cuotas{margin:0 0 8px;font-size:12.5px;line-height:1.3;color:#6B5A61;width:100%;flex-basis:100%;text-align:center}'+
    '#sb-cuotas b{color:#8C1D40;font-weight:700}'+
    '#sb-tabs{display:none}'+
    '#sb-top{display:none}'+
    '@media (max-width:749px){'+
    '#sb-top{display:block;width:100%;flex:0 0 100%;box-sizing:border-box;padding:12px 16px 6px;background:transparent}'+
    '#sb-top .k{font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#8C1D40;margin:0 0 3px}'+
    '#sb-top .t{font-size:22px;font-weight:700;line-height:1.15;color:#1E1D1B;margin:0 0 6px}'+
    '#sb-top .s{display:inline-flex;align-items:center;gap:6px;text-decoration:none;color:#8C1D40}'+
    '#sb-top .s svg{display:block}'+
    '#sb-top .s span{font-size:13px;color:#6B5A61;text-decoration:underline}'+
    '[data-sb-dup]{display:none !important}'+
    '#sb-tabs{position:fixed;top:0;left:0;right:0;z-index:950;display:flex;gap:2px;overflow-x:auto;background:#fff;border-bottom:1px solid #ECE6E8;box-shadow:0 2px 8px rgba(0,0,0,.05);padding:0 8px;transform:translateY(-110%);transition:transform .2s ease;scrollbar-width:none}'+
    '#sb-tabs.on{transform:none}'+
    '#sb-tabs::-webkit-scrollbar{display:none}'+
    '#sb-tabs a{flex:none;padding:12px 12px 10px;font-size:13px;font-weight:600;line-height:1.2;color:#6B5A61;text-decoration:none;border-bottom:2px solid transparent;white-space:nowrap}'+
    '#sb-tabs a.a{color:#8C1D40;border-bottom-color:#8C1D40}'+
    '}';
  document.head.appendChild(st);

  /* 1) Linea de cuotas justo encima del boton de compra */
  function cuotas(){
    if(document.getElementById('sb-cuotas')) return true;
    var b=mainBtn(); if(!b) return false;
    var d=document.createElement('div'); d.id='sb-cuotas';
    d.innerHTML='o paga a cuotas con <b>Addi</b> o <b>Sistecrédito</b>';
    b.insertAdjacentElement('beforebegin',d);
    return true;
  }

  /* 2) Pestañas rapidas arriba (aparecen al bajar, se esconden al subir) */
  var DEFS=[['Beneficios',/Por qu[eé] elegir/i],['Antes y después',/^\s*Antes y despu[eé]s\s*$/i],['Cómo usarlos',/C[oó]mo usarlos/i],['Reseñas',null]];
  function objetivo(d){
    if(d[1]){
      var l=nodos(d[1]);
      for(var i=0;i<l.length;i++){ var e=l[i].parentElement; if(largo(e)<80&&visible(e)) return e; }
      return null;
    }
    var r=document.querySelector('#judgeme_product_reviews,.jdgm-rev-widg,.jdgm-widget.jdgm-review-widget');
    return r&&visible(r)?r:null;
  }
  var tabs=null, items=[];
  function crearTabs(){
    if(tabs) return true;
    var ok=[]; DEFS.forEach(function(d){ var o=objetivo(d); if(o) ok.push(d); });
    if(ok.length<2) return false;
    tabs=document.createElement('nav'); tabs.id='sb-tabs'; tabs.setAttribute('aria-label','Secciones de la ficha');
    ok.forEach(function(d){
      var a=document.createElement('a'); a.href='#'; a.textContent=d[0];
      a.addEventListener('click',function(ev){
        ev.preventDefault(); var o=objetivo(d); if(!o) return;
        window.scrollTo({top:o.getBoundingClientRect().top+window.pageYOffset-56,behavior:'smooth'});
      });
      tabs.appendChild(a); items.push({d:d,a:a});
    });
    document.body.appendChild(tabs);
    var ultimo=window.pageYOffset, esperando=false;
    function revisar(){
      esperando=false;
      var y=window.pageYOffset, b=mainBtn(), pasado=b?b.getBoundingClientRect().bottom<0:y>600;
      var baja=y>ultimo+4, sube=y<ultimo-4;
      if(!pasado||sube) tabs.classList.remove('on'); else if(baja) tabs.classList.add('on');
      if(baja||sube) ultimo=y;
      var act=-1;
      items.forEach(function(it,i){ var o=objetivo(it.d); if(o&&o.getBoundingClientRect().top<=120) act=i; });
      items.forEach(function(it,i){ it.a.classList.toggle('a',i===act); });
      if(act>-1&&tabs.classList.contains('on')){ var a=items[act].a; tabs.scrollLeft=a.offsetLeft-12; }
    }
    window.addEventListener('scroll',function(){ if(!esperando){ esperando=true; requestAnimationFrame(revisar); } },{passive:true});
    return true;
  }

  /* 3) Franja de 4 iconos: se quita (por el id de cada bloque de GemPages y, de respaldo, por su texto) */
  function ocultarEl(e){ if(e&&!e.getAttribute('data-sb-off')){ e.setAttribute('data-sb-off','1'); e.style.setProperty('display','none','important'); } }
  var IDS=['g8qKYMNFmX','gJKPJa1yFX','gMqFGg0uxH','gAy4buyNB-'];
  var RES=[/de\s+calidad\s+garantizada/i,/Env[ií]os\s+express/i,/Tiempo\s+de\s+entrega\s+r/i,/Seguimiento\s+entre/i];
  function franja(){
    var sets=IDS.map(function(id,i){
      var l=[].slice.call(document.querySelectorAll('[data-id="'+id+'"]'));
      if(!l.length) l=nodos(RES[i]).map(function(x){ return x.parentElement; });
      return l;
    });
    var hecho=false;
    /* cada item (icono + texto) */
    sets.forEach(function(l){ l.forEach(function(e){
      if(!e||e.closest('#sb-conf,#sb-sticky,#sb-tabs,#sb-top')) return;
      var tx=largo(e); if(!tx||tx>80) return;
      var top=e;
      while(top.parentElement&&top.parentElement!==document.body&&largo(top.parentElement)===tx) top=top.parentElement;
      ocultarEl(top); hecho=true;
    }); });
    /* la fila completa, si contiene los 4 */
    function cuenta(x){ var c=0; sets.forEach(function(l){ if(l.some(function(e){ return x.contains(e); })) c++; }); return c; }
    (sets[3]||[]).forEach(function(a){
      var A=a;
      while(A&&A!==document.body&&cuenta(A)<4) A=A.parentElement;
      if(A&&A!==document.body&&largo(A)<400){ ocultarEl(A); hecho=true; }
    });
    return hecho;
  }

  /* 4) Titulo y estrellas arriba de las fotos (solo celular) */
  function estrella(on){
    return '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path fill="'+(on?'currentColor':'#E5CBD5')+'" d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3 6.1 20.6l1.3-6.6L2.5 9.4l6.6-.8z"/></svg>';
  }
  function topo(){
    if(document.getElementById('sb-top')) return true;
    var h1=document.querySelector('h1'); if(!h1) return false;
    var sec=h1.closest('[id^="shopify-section-"]')||h1.closest('section'); if(!sec) return false;
    var P=window.__sbPV||{}, r=Number(P.r)||0, nn=Number(P.n)||0;
    var d=document.createElement('div'); d.id='sb-top';
    var h='';
    if(P.k) h+='<div class="k">'+String(P.k).replace(/[<>&]/g,'')+'</div>';
    h+='<div class="t">'+(P.t||h1.textContent.trim()).replace(/[<>&]/g,'')+'</div>';
    if(nn>0){
      var k=Math.round(r), e=''; for(var i=1;i<=5;i++) e+=estrella(i<=k);
      h+='<a class="s" href="#resenas">'+e+'<span>'+nn+(nn===1?' reseña':' reseñas')+'</span></a>';
    }
    d.innerHTML=h;
    /* como bloque hermano ANTES de la seccion, para no alterar el diseno interno de GemPages */
    if(sec.parentNode&&sec.parentNode!==document.body) sec.insertAdjacentElement('beforebegin',d); else sec.insertAdjacentElement('afterbegin',d);
    var a=d.querySelector('.s');
    if(a) a.addEventListener('click',function(ev){
      ev.preventDefault();
      var o=document.querySelector('#judgeme_product_reviews,.jdgm-rev-widg,.jdgm-widget.jdgm-review-widget');
      if(o) window.scrollTo({top:o.getBoundingClientRect().top+window.pageYOffset-56,behavior:'smooth'});
    });
    return true;
  }
  function duplicados(){
    var h1=document.querySelector('h1'); if(!h1||!document.getElementById('sb-top')) return false;
    var P=window.__sbPV||{}, okT=false, okS=!(Number(P.n)>0), okK=!P.k;
    if(!h1.closest('#sb-top')){ h1.setAttribute('data-sb-dup','1'); okT=true; }
    function antes(p){ return !!(h1.compareDocumentPosition(p)&2)&&!p.closest('#sb-top,#sb-tabs,#sb-sticky,#sb-conf'); }
    var cand, el;
    if(!okK){
      var kk=String(P.k).trim().toLowerCase();
      cand=nodos(/\S/).filter(function(x){ return x.nodeValue.trim().toLowerCase()===kk&&antes(x.parentElement); });
      if(cand.length){ el=cand[cand.length-1].parentElement; el.setAttribute('data-sb-dup','1'); okK=true; }
    }
    if(!okS){
      cand=nodos(/^\s*\d+\s+rese[ñn]as?\s*$/i).filter(function(x){ return antes(x.parentElement); });
      if(cand.length){
        el=cand[cand.length-1].parentElement;
        var g=0;
        while(g<4&&el.parentElement&&!el.parentElement.contains(h1)&&largo(el.parentElement)<30&&!el.parentElement.querySelector('img,form')){ el=el.parentElement; g++; }
        el.setAttribute('data-sb-dup','1'); okS=true;
      }
    }
    return okT&&okS&&okK;
  }

  function seguro(fn){ try{ return fn(); }catch(e){ return false; } }
  var n=0, c=false, t=false, u=false, tp=false;
  var iv=setInterval(function(){
    n++;
    if(!c) c=seguro(cuotas);
    if(!t) t=seguro(crearTabs);
    if(!tp) tp=seguro(topo);
    if(tp&&!u) u=seguro(duplicados);
    if((c&&t&&u)||n>30) clearInterval(iv);
  },400);
  var m=0, iv2=setInterval(function(){ m++; seguro(franja); if(m>40) clearInterval(iv2); },300);
})();